<template>
  <v-card-text>
    <!-- Document dialog -->
    <document-dialog
      :isOpen="type === 'PDF'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- VDO dialog -->
    <video-dialog
      :isOpen="type === 'VDO'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- YOUTUBE dialog -->
    <youtube-dialog
      :isOpen="type === 'YOUTUBE'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- E-Book dialog -->
    <ebook-dialog
      :isOpen="type === 'BOOK'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Other file dialog (attach dialog) -->
    <attach-dialog
      :isOpen="type === 'FILE'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- URL dialog -->
    <url-dialog
      :isOpen="type === 'URL'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Article dialog -->
    <article-dialog
      :isOpen="type === 'BLOG'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Images dialog -->
    <image-dialog
      :isOpen="type === 'IMG'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    />

    <!-- Exam dialog -->
    <!-- <exam-dialog
      :isOpen="type === 'EXAM'"
      :isLectureOpen="dialog"
      :sectionId.sync="sectionId"
      :lectureId.sync="lectureId"
      :lectures.sync="lectures"
      :reload="reload"
      :closeDialog="closeDialog"
      :closeLectureDialog="closeLectureDialog"
    /> -->
  </v-card-text>
</template>
<script>
import documentDialog from "@/views/course/lectures/document.vue";
import imageDialog from "@/views/course/lectures/image.vue";
import ebookDialog from "@/views/course/lectures/ebook.vue";
import attachDialog from "@/views/course/lectures/otherfile.vue";
import urlDialog from "@/views/course/lectures/url.vue";
import articleDialog from "@/views/course/lectures/article.vue";
import videoDialog from "@/views/course/lectures/video-AntMedia.vue";
import youtubeDialog from "@/views/course/lectures/youtube.vue";
//import examDialog from "@/views/course/lectures/exam/examManagement.vue";
export default {
  props: {
    type: {
      type: String
    },
    sectionId: {
      type: String
    },
    lectures: {},
    lectureId: {},
    reload: {
      type: Function
    },
    closeLectureDialog: {
      type: Function,
    },
    courseId: {
      type: String
    }
  },
  components: {
    documentDialog,
    imageDialog,
    ebookDialog,
    attachDialog,
    urlDialog,
    articleDialog,
    videoDialog,
    youtubeDialog,
  //  examDialog
  },
  data() {
    return {
      maxWidth: "40%",
      dialog: false,
      dialog_video: false,
      dialog_youtube: false,
      dialog_document: false,
      dialog_image: false,
      dialog_ebook: false,
      dialog_url: false,
      dialog_attach: false,
      dialog_article: false,
      dialog_exam: false,
      notifications: false,
      id: "",
      sound: true,
      widgets: false,
      nameRules: [
        v => !!v || "Title is required",
        v => (v && v.length <= 50) || "Title must be less than 50 characters"
      ],
      fileRules: [v => !!v || "file is required"],
      urlRules: [v => !!v || "file is required"]
    };
  },
  methods: {
    // closeDialog(){
    //   this.dialog=false
    //   this.closeLectureDialog()
    // },
    closeDialog(){
    },
    // closeLectureDialog(){
    //   this.dialog_video = false
    //   this.dialog_document = false
    //   this.dialog_image = false
    //   this.dialog_ebook = false
    //   this.dialog_url = false
    //   this.dialog_attach = false
    //   this.dialog_article = false
    //   this.dialog_exam = false
    // }
  },
  beforeMount() {
    // console.log(this.lectures)
    if (window.screen.width < 600) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 600 && window.screen.width < 960) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 960 && window.screen.width < 1264) {
      this.maxWidth = "90%";
    } else if (window.screen.width > 1264 && window.screen.width < 1904) {
      this.maxWidth = "40%";
    } else {
      this.maxWidth = "40%";
    }
  },
  watch: {
    type(newValue) {
      if (newValue == 'EXAM') {
        this.$router.push({
          name: 'tab-exam',
          query: { id: this.courseId, lectureId: this.lectureId, sectionId: this.sectionId, type: newValue },
        });
      }
    },
  },
};
</script>
<style scoped>
.cardTextStyle {
  /* height: 800px; */
  /* text-align: center; */
}
/* .buttonTypeContent{
  width: 100%;
  height: 200px;
} */
.dialogStyle {
  height: 1000px;
}
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.buttonTypeContent.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  width: 100%;
  padding-bottom: 50%; /* 1:1 Aspect Ratio */
  padding-top: 50%;
  border-radius: 50px;
}
.textInbutton.v-btn__content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
}
.colCenter {
  text-align: center;
}
.textField {
  width: 100%;
}
.labelAttach.v-label.theme--light {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 30px;
}
p {
  margin: 0 0 5px;
}
.examplePDF {
  /* height: 450px; */
  text-align: center;
}
.iframePDF {
  width: 200px;
  height: 300px;
  /* overflow: hidden; */
}
.iframeWeb {
  width: 100%;
  height: auto;
  /* overflow: hidden; */
}
.explainFile {
  width: 100%;
  min-height: 150px;
  height: auto;
  margin-top: 7%;
}
.v-card__text.dialogStyle {
  height: 1000px;
  width: 70%;
  margin: 0 auto;
}
.manageButton {
  justify-content: flex-end;
}
.textAreaDetail {
  border-radius: 15px;
}
.divExplanFile {
  justify-content: flex-end;
}
.headExplan {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.labelExplan {
  text-align: justify;
}
@media only screen and (max-width: 1024px) {
  .v-card__text.dialogStyle {
    width: 100%;
    margin: 0 auto;
  }
}
/* @media only screen and (max-width: 600px ){
  .col {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}
} */
</style>
